/* parser generated by jison 0.4.2 */
var exprParser = (function(){
var parser = {trace: function trace() { },
yy: {},
symbols_: {"error":2,"expressions":3,"logic_expr":4,"EOF":5,"math_expr":6,"compare_expr":7,"AND":8,"OR":9,"NOT":10,"(":11,")":12,"=":13,">":14,"<":15,">=":16,"<=":17,"!=":18,"identifier":19,"const":20,"array":21,"func":22,"index":23,"attr":24,"+":25,"-":26,"*":27,"/":28,"params":29,",":30,"ID":31,"INT":32,"REAL":33,"STR":34,"[":35,"list":36,"]":37,"int":38,".":39,":":40,"$accept":0,"$end":1},
terminals_: {2:"error",5:"EOF",8:"AND",9:"OR",10:"NOT",11:"(",12:")",13:"=",14:">",15:"<",16:">=",17:"<=",18:"!=",25:"+",26:"-",27:"*",28:"/",30:",",31:"ID",32:"INT",33:"REAL",34:"STR",35:"[",37:"]",39:".",40:":"},
productions_: [0,[3,2],[3,2],[4,1],[4,3],[4,3],[4,2],[4,3],[7,3],[7,3],[7,3],[7,3],[7,3],[7,3],[6,1],[6,1],[6,1],[6,1],[6,1],[6,1],[6,3],[6,3],[6,3],[6,3],[6,3],[29,1],[29,3],[19,1],[20,1],[20,1],[20,1],[20,3],[38,1],[36,1],[36,1],[36,1],[36,3],[36,3],[36,3],[24,3],[24,3],[24,3],[21,6],[21,5],[21,5],[22,4],[23,4],[23,4],[23,3],[23,3]],
performAction: function anonymous(yytext,yyleng,yylineno,yy,yystate,$$,_$) {

var $0 = $$.length - 1;
switch (yystate) {
case 1: return $$[$0-1]; 
break;
case 2: return $$[$0-1]; 
break;
case 3:this.$ = $$[$0];
break;
case 4:this.$ = {type:'connective', op:'and', left: $$[$0-2], right: $$[$0]};
break;
case 5:this.$ = {type:'connective', op:'or', left: $$[$0-2], right: $$[$0]};
break;
case 6:this.$ = {type:'connective', op:'not', left: $$[$0]};
break;
case 7:this.$ = $$[$0-1];
break;
case 8:this.$ = {type:'compare',op:'=',left: $$[$0-2], right: $$[$0]};
break;
case 9:this.$ = {type:'compare',op:'>',left: $$[$0-2], right: $$[$0]};
break;
case 10:this.$ = {type:'compare',op:'<',left: $$[$0-2], right: $$[$0]};
break;
case 11:this.$ = {type:'compare',op:'>=',left: $$[$0-2], right: $$[$0]};
break;
case 12:this.$ = {type:'compare',op:'<=',left: $$[$0-2], right: $$[$0]};
break;
case 13:this.$ = {type:'compare',op:'!=',left: $$[$0-2], right: $$[$0]};
break;
case 14:this.$ = $$[$0];
break;
case 15:this.$ = $$[$0];
break;
case 16:this.$ = $$[$0];
break;
case 17:this.$ = $$[$0];
break;
case 18:this.$ = $$[$0];
break;
case 19:this.$ = $$[$0];
break;
case 20:this.$ = {type:'math', op:'+', left: $$[$0-2], right: $$[$0]};
break;
case 21:this.$ = {type:'math', op:'-', left: $$[$0-2], right: $$[$0]};
break;
case 22:this.$ = {type:'math', op:'*', left: $$[$0-2], right: $$[$0]};
break;
case 23:this.$ = {type:'math', op:'/', left: $$[$0-2], right: $$[$0]};
break;
case 24:this.$ = $$[$0-1];
break;
case 25:this.$ = [$$[$0]]
break;
case 26:this.$ = $$[$0].concat([$$[$0-2]]);
break;
case 27:this.$ = {type:'id',value:yytext};
break;
case 28:this.$ = {type:'const',value:parseInt(yytext)};
break;
case 29:this.$ = {type:'const',value:parseFloat(yytext)};
break;
case 30:this.$ = {type:'const',value:yytext.replace(/\'|\"/g,'')};
break;
case 31:this.$ = {type:'const',value:$$[$0-1]};
break;
case 32:this.$ = {type:'const',value:parseInt(yytext)};
break;
case 33:this.$ = [$$[$0]]
break;
case 34:this.$ = [$$[$0]]
break;
case 35:this.$ = [$$[$0].replace(/\'|\"/g,'')]
break;
case 36:this.$ = $$[$0].concat([$$[$0-2]]);
break;
case 37:this.$ = $$[$0].concat([$$[$0-2]]);
break;
case 38:this.$ = $$[$0].concat([$$[$0-2].replace(/\'|\"/g,'')]);
break;
case 39:this.$ = {type:'attr',id:$$[$0-2], attr:$$[$0]};
break;
case 40:this.$ = {type:'attr',id:$$[$0-2], attr:$$[$0]};
break;
case 41:this.$ = {type:'attr',id:$$[$0-2], attr:$$[$0]};
break;
case 42:this.$ = {type:'array',id:$$[$0-5], start:$$[$0-3], end:$$[$0-1]};
break;
case 43:this.$ = {type:'array',id:$$[$0-4], start:$$[$0-2]};
break;
case 44:this.$ = {type:'array',id:$$[$0-4], end:$$[$0-1]};
break;
case 45:this.$ = {type:'func',id:$$[$0-3], params:$$[$0-1]};
break;
case 46:this.$ = {type:'index',id:$$[$0-3], index:$$[$0-1]};
break;
case 47:this.$ = {type:'index',id:$$[$0-3], index:$$[$0-1]};
break;
case 48:this.$ = {type:'index',id:$$[$0-2], index:$$[$0]};
break;
case 49:this.$ = {type:'index',id:$$[$0-2], index:$$[$0]};
break;
}
},
table: [{3:1,4:2,6:3,7:4,10:[1,5],11:[1,6],19:7,20:8,21:9,22:10,23:11,24:12,31:[1,13],32:[1,14],33:[1,15],34:[1,16],35:[1,17]},{1:[3]},{5:[1,18],8:[1,19],9:[1,20]},{5:[1,21],13:[1,26],14:[1,27],15:[1,28],16:[1,29],17:[1,30],18:[1,31],25:[1,22],26:[1,23],27:[1,24],28:[1,25]},{5:[2,3],8:[2,3],9:[2,3],12:[2,3]},{4:32,6:33,7:4,10:[1,5],11:[1,6],19:7,20:8,21:9,22:10,23:11,24:12,31:[1,13],32:[1,14],33:[1,15],34:[1,16],35:[1,17]},{4:34,6:35,7:4,10:[1,5],11:[1,6],19:7,20:8,21:9,22:10,23:11,24:12,31:[1,13],32:[1,14],33:[1,15],34:[1,16],35:[1,17]},{5:[2,14],8:[2,14],9:[2,14],11:[1,37],12:[2,14],13:[2,14],14:[2,14],15:[2,14],16:[2,14],17:[2,14],18:[2,14],25:[2,14],26:[2,14],27:[2,14],28:[2,14],30:[2,14],35:[1,36],37:[2,14],39:[1,38],40:[2,14]},{5:[2,15],8:[2,15],9:[2,15],12:[2,15],13:[2,15],14:[2,15],15:[2,15],16:[2,15],17:[2,15],18:[2,15],25:[2,15],26:[2,15],27:[2,15],28:[2,15],30:[2,15],37:[2,15],40:[2,15]},{5:[2,16],8:[2,16],9:[2,16],12:[2,16],13:[2,16],14:[2,16],15:[2,16],16:[2,16],17:[2,16],18:[2,16],25:[2,16],26:[2,16],27:[2,16],28:[2,16],30:[2,16],35:[1,39],37:[2,16],39:[1,40],40:[2,16]},{5:[2,17],8:[2,17],9:[2,17],12:[2,17],13:[2,17],14:[2,17],15:[2,17],16:[2,17],17:[2,17],18:[2,17],25:[2,17],26:[2,17],27:[2,17],28:[2,17],30:[2,17],37:[2,17],40:[2,17]},{5:[2,18],8:[2,18],9:[2,18],12:[2,18],13:[2,18],14:[2,18],15:[2,18],16:[2,18],17:[2,18],18:[2,18],25:[2,18],26:[2,18],27:[2,18],28:[2,18],30:[2,18],37:[2,18],39:[1,41],40:[2,18]},{5:[2,19],8:[2,19],9:[2,19],12:[2,19],13:[2,19],14:[2,19],15:[2,19],16:[2,19],17:[2,19],18:[2,19],25:[2,19],26:[2,19],27:[2,19],28:[2,19],30:[2,19],37:[2,19],40:[2,19]},{5:[2,27],8:[2,27],9:[2,27],11:[2,27],12:[2,27],13:[2,27],14:[2,27],15:[2,27],16:[2,27],17:[2,27],18:[2,27],25:[2,27],26:[2,27],27:[2,27],28:[2,27],30:[2,27],35:[2,27],37:[2,27],39:[2,27],40:[2,27]},{5:[2,28],8:[2,28],9:[2,28],12:[2,28],13:[2,28],14:[2,28],15:[2,28],16:[2,28],17:[2,28],18:[2,28],25:[2,28],26:[2,28],27:[2,28],28:[2,28],30:[2,28],37:[2,28],40:[2,28]},{5:[2,29],8:[2,29],9:[2,29],12:[2,29],13:[2,29],14:[2,29],15:[2,29],16:[2,29],17:[2,29],18:[2,29],25:[2,29],26:[2,29],27:[2,29],28:[2,29],30:[2,29],37:[2,29],40:[2,29]},{5:[2,30],8:[2,30],9:[2,30],12:[2,30],13:[2,30],14:[2,30],15:[2,30],16:[2,30],17:[2,30],18:[2,30],25:[2,30],26:[2,30],27:[2,30],28:[2,30],30:[2,30],37:[2,30],40:[2,30]},{32:[1,43],33:[1,44],34:[1,45],36:42},{1:[2,1]},{4:46,6:33,7:4,10:[1,5],11:[1,6],19:7,20:8,21:9,22:10,23:11,24:12,31:[1,13],32:[1,14],33:[1,15],34:[1,16],35:[1,17]},{4:47,6:33,7:4,10:[1,5],11:[1,6],19:7,20:8,21:9,22:10,23:11,24:12,31:[1,13],32:[1,14],33:[1,15],34:[1,16],35:[1,17]},{1:[2,2]},{6:48,11:[1,49],19:7,20:8,21:9,22:10,23:11,24:12,31:[1,13],32:[1,14],33:[1,15],34:[1,16],35:[1,17]},{6:50,11:[1,49],19:7,20:8,21:9,22:10,23:11,24:12,31:[1,13],32:[1,14],33:[1,15],34:[1,16],35:[1,17]},{6:51,11:[1,49],19:7,20:8,21:9,22:10,23:11,24:12,31:[1,13],32:[1,14],33:[1,15],34:[1,16],35:[1,17]},{6:52,11:[1,49],19:7,20:8,21:9,22:10,23:11,24:12,31:[1,13],32:[1,14],33:[1,15],34:[1,16],35:[1,17]},{6:53,11:[1,49],19:7,20:8,21:9,22:10,23:11,24:12,31:[1,13],32:[1,14],33:[1,15],34:[1,16],35:[1,17]},{6:54,11:[1,49],19:7,20:8,21:9,22:10,23:11,24:12,31:[1,13],32:[1,14],33:[1,15],34:[1,16],35:[1,17]},{6:55,11:[1,49],19:7,20:8,21:9,22:10,23:11,24:12,31:[1,13],32:[1,14],33:[1,15],34:[1,16],35:[1,17]},{6:56,11:[1,49],19:7,20:8,21:9,22:10,23:11,24:12,31:[1,13],32:[1,14],33:[1,15],34:[1,16],35:[1,17]},{6:57,11:[1,49],19:7,20:8,21:9,22:10,23:11,24:12,31:[1,13],32:[1,14],33:[1,15],34:[1,16],35:[1,17]},{6:58,11:[1,49],19:7,20:8,21:9,22:10,23:11,24:12,31:[1,13],32:[1,14],33:[1,15],34:[1,16],35:[1,17]},{5:[2,6],8:[2,6],9:[2,6],12:[2,6]},{13:[1,26],14:[1,27],15:[1,28],16:[1,29],17:[1,30],18:[1,31],25:[1,22],26:[1,23],27:[1,24],28:[1,25]},{8:[1,19],9:[1,20],12:[1,59]},{12:[1,60],13:[1,26],14:[1,27],15:[1,28],16:[1,29],17:[1,30],18:[1,31],25:[1,22],26:[1,23],27:[1,24],28:[1,25]},{6:61,11:[1,49],19:7,20:8,21:9,22:10,23:11,24:12,31:[1,13],32:[1,14],33:[1,15],34:[1,16],35:[1,17],40:[1,62]},{6:64,11:[1,49],19:7,20:8,21:9,22:10,23:11,24:12,29:63,31:[1,13],32:[1,14],33:[1,15],34:[1,16],35:[1,17]},{19:66,31:[1,13],32:[1,67],38:65},{6:68,11:[1,49],19:7,20:8,21:9,22:10,23:11,24:12,31:[1,13],32:[1,14],33:[1,15],34:[1,16],35:[1,17]},{19:70,31:[1,13],32:[1,67],38:69},{19:71,31:[1,13]},{37:[1,72]},{30:[1,73],37:[2,33]},{30:[1,74],37:[2,34]},{30:[1,75],37:[2,35]},{5:[2,4],8:[2,4],9:[2,4],12:[2,4]},{5:[2,5],8:[1,19],9:[2,5],12:[2,5]},{5:[2,20],8:[2,20],9:[2,20],12:[2,20],13:[2,20],14:[2,20],15:[2,20],16:[2,20],17:[2,20],18:[2,20],25:[2,20],26:[2,20],27:[1,24],28:[1,25],30:[2,20],37:[2,20],40:[2,20]},{6:76,11:[1,49],19:7,20:8,21:9,22:10,23:11,24:12,31:[1,13],32:[1,14],33:[1,15],34:[1,16],35:[1,17]},{5:[2,21],8:[2,21],9:[2,21],12:[2,21],13:[2,21],14:[2,21],15:[2,21],16:[2,21],17:[2,21],18:[2,21],25:[2,21],26:[2,21],27:[1,24],28:[1,25],30:[2,21],37:[2,21],40:[2,21]},{5:[2,22],8:[2,22],9:[2,22],12:[2,22],13:[2,22],14:[2,22],15:[2,22],16:[2,22],17:[2,22],18:[2,22],25:[2,22],26:[2,22],27:[2,22],28:[2,22],30:[2,22],37:[2,22],40:[2,22]},{5:[2,23],8:[2,23],9:[2,23],12:[2,23],13:[2,23],14:[2,23],15:[2,23],16:[2,23],17:[2,23],18:[2,23],25:[2,23],26:[2,23],27:[2,23],28:[2,23],30:[2,23],37:[2,23],40:[2,23]},{5:[2,8],8:[2,8],9:[2,8],12:[2,8],25:[1,22],26:[1,23],27:[1,24],28:[1,25]},{5:[2,9],8:[2,9],9:[2,9],12:[2,9],25:[1,22],26:[1,23],27:[1,24],28:[1,25]},{5:[2,10],8:[2,10],9:[2,10],12:[2,10],25:[1,22],26:[1,23],27:[1,24],28:[1,25]},{5:[2,11],8:[2,11],9:[2,11],12:[2,11],25:[1,22],26:[1,23],27:[1,24],28:[1,25]},{5:[2,12],8:[2,12],9:[2,12],12:[2,12],25:[1,22],26:[1,23],27:[1,24],28:[1,25]},{5:[2,13],8:[2,13],9:[2,13],12:[2,13],25:[1,22],26:[1,23],27:[1,24],28:[1,25]},{5:[2,7],8:[2,7],9:[2,7],12:[2,7]},{5:[2,24],8:[2,24],9:[2,24],12:[2,24],13:[2,24],14:[2,24],15:[2,24],16:[2,24],17:[2,24],18:[2,24],25:[2,24],26:[2,24],27:[2,24],28:[2,24],30:[2,24],37:[2,24],40:[2,24]},{25:[1,22],26:[1,23],27:[1,24],28:[1,25],37:[1,78],40:[1,77]},{6:79,11:[1,49],19:7,20:8,21:9,22:10,23:11,24:12,31:[1,13],32:[1,14],33:[1,15],34:[1,16],35:[1,17]},{12:[1,80]},{12:[2,25],25:[1,22],26:[1,23],27:[1,24],28:[1,25],30:[1,81]},{5:[2,48],8:[2,48],9:[2,48],12:[2,48],13:[2,48],14:[2,48],15:[2,48],16:[2,48],17:[2,48],18:[2,48],25:[2,48],26:[2,48],27:[2,48],28:[2,48],30:[2,48],37:[2,48],39:[2,48],40:[2,48]},{5:[2,39],8:[2,39],9:[2,39],12:[2,39],13:[2,39],14:[2,39],15:[2,39],16:[2,39],17:[2,39],18:[2,39],25:[2,39],26:[2,39],27:[2,39],28:[2,39],30:[2,39],37:[2,39],40:[2,39]},{5:[2,32],8:[2,32],9:[2,32],12:[2,32],13:[2,32],14:[2,32],15:[2,32],16:[2,32],17:[2,32],18:[2,32],25:[2,32],26:[2,32],27:[2,32],28:[2,32],30:[2,32],37:[2,32],39:[2,32],40:[2,32]},{25:[1,22],26:[1,23],27:[1,24],28:[1,25],37:[1,82]},{5:[2,49],8:[2,49],9:[2,49],12:[2,49],13:[2,49],14:[2,49],15:[2,49],16:[2,49],17:[2,49],18:[2,49],25:[2,49],26:[2,49],27:[2,49],28:[2,49],30:[2,49],37:[2,49],39:[2,49],40:[2,49]},{5:[2,41],8:[2,41],9:[2,41],12:[2,41],13:[2,41],14:[2,41],15:[2,41],16:[2,41],17:[2,41],18:[2,41],25:[2,41],26:[2,41],27:[2,41],28:[2,41],30:[2,41],37:[2,41],40:[2,41]},{5:[2,40],8:[2,40],9:[2,40],12:[2,40],13:[2,40],14:[2,40],15:[2,40],16:[2,40],17:[2,40],18:[2,40],25:[2,40],26:[2,40],27:[2,40],28:[2,40],30:[2,40],37:[2,40],40:[2,40]},{5:[2,31],8:[2,31],9:[2,31],12:[2,31],13:[2,31],14:[2,31],15:[2,31],16:[2,31],17:[2,31],18:[2,31],25:[2,31],26:[2,31],27:[2,31],28:[2,31],30:[2,31],37:[2,31],40:[2,31]},{32:[1,43],33:[1,44],34:[1,45],36:83},{32:[1,43],33:[1,44],34:[1,45],36:84},{32:[1,43],33:[1,44],34:[1,45],36:85},{12:[1,60],25:[1,22],26:[1,23],27:[1,24],28:[1,25]},{6:86,11:[1,49],19:7,20:8,21:9,22:10,23:11,24:12,31:[1,13],32:[1,14],33:[1,15],34:[1,16],35:[1,17],37:[1,87]},{5:[2,46],8:[2,46],9:[2,46],12:[2,46],13:[2,46],14:[2,46],15:[2,46],16:[2,46],17:[2,46],18:[2,46],25:[2,46],26:[2,46],27:[2,46],28:[2,46],30:[2,46],37:[2,46],39:[2,46],40:[2,46]},{25:[1,22],26:[1,23],27:[1,24],28:[1,25],37:[1,88]},{5:[2,45],8:[2,45],9:[2,45],12:[2,45],13:[2,45],14:[2,45],15:[2,45],16:[2,45],17:[2,45],18:[2,45],25:[2,45],26:[2,45],27:[2,45],28:[2,45],30:[2,45],37:[2,45],40:[2,45]},{6:64,11:[1,49],19:7,20:8,21:9,22:10,23:11,24:12,29:89,31:[1,13],32:[1,14],33:[1,15],34:[1,16],35:[1,17]},{5:[2,47],8:[2,47],9:[2,47],12:[2,47],13:[2,47],14:[2,47],15:[2,47],16:[2,47],17:[2,47],18:[2,47],25:[2,47],26:[2,47],27:[2,47],28:[2,47],30:[2,47],37:[2,47],39:[2,47],40:[2,47]},{37:[2,36]},{37:[2,37]},{37:[2,38]},{25:[1,22],26:[1,23],27:[1,24],28:[1,25],37:[1,90]},{5:[2,43],8:[2,43],9:[2,43],12:[2,43],13:[2,43],14:[2,43],15:[2,43],16:[2,43],17:[2,43],18:[2,43],25:[2,43],26:[2,43],27:[2,43],28:[2,43],30:[2,43],35:[2,43],37:[2,43],39:[2,43],40:[2,43]},{5:[2,44],8:[2,44],9:[2,44],12:[2,44],13:[2,44],14:[2,44],15:[2,44],16:[2,44],17:[2,44],18:[2,44],25:[2,44],26:[2,44],27:[2,44],28:[2,44],30:[2,44],35:[2,44],37:[2,44],39:[2,44],40:[2,44]},{12:[2,26]},{5:[2,42],8:[2,42],9:[2,42],12:[2,42],13:[2,42],14:[2,42],15:[2,42],16:[2,42],17:[2,42],18:[2,42],25:[2,42],26:[2,42],27:[2,42],28:[2,42],30:[2,42],35:[2,42],37:[2,42],39:[2,42],40:[2,42]}],
defaultActions: {18:[2,1],21:[2,2],83:[2,36],84:[2,37],85:[2,38],89:[2,26]},
parseError: function parseError(str, hash) {
    throw new Error(str);
},
parse: function parse(input) {
    var self = this, stack = [0], vstack = [null], lstack = [], table = this.table, yytext = "", yylineno = 0, yyleng = 0, recovering = 0, TERROR = 2, EOF = 1;
    this.lexer.setInput(input);
    this.lexer.yy = this.yy;
    this.yy.lexer = this.lexer;
    this.yy.parser = this;
    if (typeof this.lexer.yylloc == "undefined")
        this.lexer.yylloc = {};
    var yyloc = this.lexer.yylloc;
    lstack.push(yyloc);
    var ranges = this.lexer.options && this.lexer.options.ranges;
    if (typeof this.yy.parseError === "function")
        this.parseError = this.yy.parseError;
    function popStack(n) {
        stack.length = stack.length - 2 * n;
        vstack.length = vstack.length - n;
        lstack.length = lstack.length - n;
    }
    function lex() {
        var token;
        token = self.lexer.lex() || 1;
        if (typeof token !== "number") {
            token = self.symbols_[token] || token;
        }
        return token;
    }
    var symbol, preErrorSymbol, state, action, a, r, yyval = {}, p, len, newState, expected;
    while (true) {
        state = stack[stack.length - 1];
        if (this.defaultActions[state]) {
            action = this.defaultActions[state];
        } else {
            if (symbol === null || typeof symbol == "undefined") {
                symbol = lex();
            }
            action = table[state] && table[state][symbol];
        }
        if (typeof action === "undefined" || !action.length || !action[0]) {
            var errStr = "";
            if (!recovering) {
                expected = [];
                for (p in table[state])
                    if (this.terminals_[p] && p > 2) {
                        expected.push("'" + this.terminals_[p] + "'");
                    }
                if (this.lexer.showPosition) {
                    errStr = "Parse error on line " + (yylineno + 1) + ":\n" + this.lexer.showPosition() + "\nExpecting " + expected.join(", ") + ", got '" + (this.terminals_[symbol] || symbol) + "'";
                } else {
                    errStr = "Parse error on line " + (yylineno + 1) + ": Unexpected " + (symbol == 1?"end of input":"'" + (this.terminals_[symbol] || symbol) + "'");
                }
                this.parseError(errStr, {text: this.lexer.match, token: this.terminals_[symbol] || symbol, line: this.lexer.yylineno, loc: yyloc, expected: expected});
            }
        }
        if (action[0] instanceof Array && action.length > 1) {
            throw new Error("Parse Error: multiple actions possible at state: " + state + ", token: " + symbol);
        }
        switch (action[0]) {
        case 1:
            stack.push(symbol);
            vstack.push(this.lexer.yytext);
            lstack.push(this.lexer.yylloc);
            stack.push(action[1]);
            symbol = null;
            if (!preErrorSymbol) {
                yyleng = this.lexer.yyleng;
                yytext = this.lexer.yytext;
                yylineno = this.lexer.yylineno;
                yyloc = this.lexer.yylloc;
                if (recovering > 0)
                    recovering--;
            } else {
                symbol = preErrorSymbol;
                preErrorSymbol = null;
            }
            break;
        case 2:
            len = this.productions_[action[1]][1];
            yyval.$ = vstack[vstack.length - len];
            yyval._$ = {first_line: lstack[lstack.length - (len || 1)].first_line, last_line: lstack[lstack.length - 1].last_line, first_column: lstack[lstack.length - (len || 1)].first_column, last_column: lstack[lstack.length - 1].last_column};
            if (ranges) {
                yyval._$.range = [lstack[lstack.length - (len || 1)].range[0], lstack[lstack.length - 1].range[1]];
            }
            r = this.performAction.call(yyval, yytext, yyleng, yylineno, this.yy, action[1], vstack, lstack);
            if (typeof r !== "undefined") {
                return r;
            }
            if (len) {
                stack = stack.slice(0, -1 * len * 2);
                vstack = vstack.slice(0, -1 * len);
                lstack = lstack.slice(0, -1 * len);
            }
            stack.push(this.productions_[action[1]][0]);
            vstack.push(yyval.$);
            lstack.push(yyval._$);
            newState = table[stack[stack.length - 2]][stack[stack.length - 1]];
            stack.push(newState);
            break;
        case 3:
            return true;
        }
    }
    return true;
}
};
/* generated by jison-lex 0.1.0 */
var lexer = (function(){
var lexer = {
EOF:1,
parseError:function parseError(str, hash) {
        if (this.yy.parser) {
            this.yy.parser.parseError(str, hash);
        } else {
            throw new Error(str);
        }
    },
setInput:function (input) {
        this._input = input;
        this._more = this._less = this.done = false;
        this.yylineno = this.yyleng = 0;
        this.yytext = this.matched = this.match = '';
        this.conditionStack = ['INITIAL'];
        this.yylloc = {first_line:1,first_column:0,last_line:1,last_column:0};
        if (this.options.ranges) this.yylloc.range = [0,0];
        this.offset = 0;
        return this;
    },
input:function () {
        var ch = this._input[0];
        this.yytext += ch;
        this.yyleng++;
        this.offset++;
        this.match += ch;
        this.matched += ch;
        var lines = ch.match(/(?:\r\n?|\n).*/g);
        if (lines) {
            this.yylineno++;
            this.yylloc.last_line++;
        } else {
            this.yylloc.last_column++;
        }
        if (this.options.ranges) this.yylloc.range[1]++;

        this._input = this._input.slice(1);
        return ch;
    },
unput:function (ch) {
        var len = ch.length;
        var lines = ch.split(/(?:\r\n?|\n)/g);

        this._input = ch + this._input;
        this.yytext = this.yytext.substr(0, this.yytext.length-len-1);
        //this.yyleng -= len;
        this.offset -= len;
        var oldLines = this.match.split(/(?:\r\n?|\n)/g);
        this.match = this.match.substr(0, this.match.length-1);
        this.matched = this.matched.substr(0, this.matched.length-1);

        if (lines.length-1) this.yylineno -= lines.length-1;
        var r = this.yylloc.range;

        this.yylloc = {first_line: this.yylloc.first_line,
          last_line: this.yylineno+1,
          first_column: this.yylloc.first_column,
          last_column: lines ?
              (lines.length === oldLines.length ? this.yylloc.first_column : 0) + oldLines[oldLines.length - lines.length].length - lines[0].length:
              this.yylloc.first_column - len
          };

        if (this.options.ranges) {
            this.yylloc.range = [r[0], r[0] + this.yyleng - len];
        }
        return this;
    },
more:function () {
        this._more = true;
        return this;
    },
less:function (n) {
        this.unput(this.match.slice(n));
    },
pastInput:function () {
        var past = this.matched.substr(0, this.matched.length - this.match.length);
        return (past.length > 20 ? '...':'') + past.substr(-20).replace(/\n/g, "");
    },
upcomingInput:function () {
        var next = this.match;
        if (next.length < 20) {
            next += this._input.substr(0, 20-next.length);
        }
        return (next.substr(0,20)+(next.length > 20 ? '...':'')).replace(/\n/g, "");
    },
showPosition:function () {
        var pre = this.pastInput();
        var c = new Array(pre.length + 1).join("-");
        return pre + this.upcomingInput() + "\n" + c+"^";
    },
next:function () {
        if (this.done) {
            return this.EOF;
        }
        if (!this._input) this.done = true;

        var token,
            match,
            tempMatch,
            index,
            col,
            lines;
        if (!this._more) {
            this.yytext = '';
            this.match = '';
        }
        var rules = this._currentRules();
        for (var i=0;i < rules.length; i++) {
            tempMatch = this._input.match(this.rules[rules[i]]);
            if (tempMatch && (!match || tempMatch[0].length > match[0].length)) {
                match = tempMatch;
                index = i;
                if (!this.options.flex) break;
            }
        }
        if (match) {
            lines = match[0].match(/(?:\r\n?|\n).*/g);
            if (lines) this.yylineno += lines.length;
            this.yylloc = {first_line: this.yylloc.last_line,
                           last_line: this.yylineno+1,
                           first_column: this.yylloc.last_column,
                           last_column: lines ? lines[lines.length-1].length-lines[lines.length-1].match(/\r?\n?/)[0].length : this.yylloc.last_column + match[0].length};
            this.yytext += match[0];
            this.match += match[0];
            this.matches = match;
            this.yyleng = this.yytext.length;
            if (this.options.ranges) {
                this.yylloc.range = [this.offset, this.offset += this.yyleng];
            }
            this._more = false;
            this._input = this._input.slice(match[0].length);
            this.matched += match[0];
            token = this.performAction.call(this, this.yy, this, rules[index],this.conditionStack[this.conditionStack.length-1]);
            if (this.done && this._input) this.done = false;
            if (token) return token;
            else return;
        }
        if (this._input === "") {
            return this.EOF;
        } else {
            return this.parseError('Lexical error on line '+(this.yylineno+1)+'. Unrecognized text.\n'+this.showPosition(),
                    {text: "", token: null, line: this.yylineno});
        }
    },
lex:function lex() {
        var r = this.next();
        if (typeof r !== 'undefined') {
            return r;
        } else {
            return this.lex();
        }
    },
begin:function begin(condition) {
        this.conditionStack.push(condition);
    },
popState:function popState() {
        return this.conditionStack.pop();
    },
_currentRules:function _currentRules() {
        return this.conditions[this.conditionStack[this.conditionStack.length-1]].rules;
    },
topState:function () {
        return this.conditionStack[this.conditionStack.length-2];
    },
pushState:function begin(condition) {
        this.begin(condition);
    },
options: {},
performAction: function anonymous(yy,yy_,$avoiding_name_collisions,YY_START) {

var YYSTATE=YY_START;
switch($avoiding_name_collisions) {
case 0:/* skip whitespace */
break;
case 1:return 8
break;
case 2:return 9
break;
case 3:return 10
break;
case 4:return 33
break;
case 5:return 32
break;
case 6:return 34
break;
case 7:return 31
break;
case 8:return 25
break;
case 9:return 26
break;
case 10:return 27
break;
case 11:return 28
break;
case 12:return 16
break;
case 13:return 17
break;
case 14:return 13
break;
case 15:return 14
break;
case 16:return 15
break;
case 17:return 18
break;
case 18:return 11
break;
case 19:return 12
break;
case 20:return 35
break;
case 21:return 37
break;
case 22:return 39
break;
case 23:return 30
break;
case 24:return 40
break;
case 25:return 5
break;
}
},
rules: [/^(?:\s+)/,/^(?:and\b)/,/^(?:or\b)/,/^(?:not\b)/,/^(?:[0-9]+\.[0-9]+\b)/,/^(?:[0-9]+\b)/,/^(?:'([^\']*)'|"([^\"]*)"\b)/,/^(?:[A-Za-z_][_:A-Za-z0-9]*\b)/,/^(?:\+)/,/^(?:-)/,/^(?:\*)/,/^(?:\/)/,/^(?:>=)/,/^(?:<=)/,/^(?:=)/,/^(?:>)/,/^(?:<)/,/^(?:!=)/,/^(?:\()/,/^(?:\))/,/^(?:\[)/,/^(?:\])/,/^(?:\.)/,/^(?:,)/,/^(?::)/,/^(?:$)/],
conditions: {"INITIAL":{"rules":[0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25],"inclusive":true}}
};
return lexer;
})();
parser.lexer = lexer;
function Parser () { this.yy = {}; }Parser.prototype = parser;parser.Parser = Parser;
return new Parser;
})();
if (typeof require !== 'undefined' && typeof exports !== 'undefined') {
exports.parser = exprParser;
exports.Parser = exprParser.Parser;
exports.parse = function () { return exprParser.parse.apply(exprParser, arguments); };
exports.main = function commonjsMain(args) {
    if (!args[1]) {
        console.log('Usage: '+args[0]+' FILE');
        process.exit(1);
    }
    var source = require('sma.fs').readFileSync(require('path').normalize(args[1]), "utf8");
    return exports.parser.parse(source);
};
if (typeof module !== 'undefined' && require.main === module) {
  exports.main(process.argv.slice(1));
}
}
